/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:03
 * @LastEditors: zxf
 * @LastEditTime: 2022-08-08 17:37:50
 * @Description: 人员签到信息路由
 */

const qdxxRoutes = {
  path: 'qdxx',
  name: 'qdxx',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'wbqd',
      name: 'wbqdIndex',
      component: () => import(/* webpackChunkName: "wbqdIndex" */ '@/features/common/qdxx/index.vue'),
      meta: {
        navtabTitle: '维保签到信息',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'jcqd',
      name: 'jcqdIndex',
      component: () => import(/* webpackChunkName: "jcqdIndex" */ '@/features/common/qdxx/index.vue'),
      meta: {
        navtabTitle: '检测签到信息',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'pgqd',
      name: 'pgqdIndex',
      component: () => import(/* webpackChunkName: "pgqdIndex" */ '@/features/common/qdxx/index.vue'),
      meta: {
        navtabTitle: '评估签到信息',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default qdxxRoutes;
